class EventBus {
    constructor() {
        this.target = new EventTarget();
    }

    emit(eventName, ...args) {
        const event = new CustomEvent(eventName, {
            detail: args,
        });

        console.debug("Event bus emit: ", eventName, ...args);

        this.target.dispatchEvent(event);
    }

    /**
     * @deprecated
     * @see emit()
     */
    $emit(eventName, ...args) {
        this.emit(eventName, ...args);
    }

    on(eventName, callback) {
        this.target.addEventListener(eventName, (event) => {
            console.debug("Event bus on: ", eventName, ...event.detail);

            callback(...event.detail);
        });
    }

    /**
     * @deprecated
     * @see on()
     */
    $on(eventName, callback) {
        this.on(eventName, callback);
    }
}

const eventBus = new EventBus();

export default eventBus;
